import { lazy, Suspense, type ComponentType, type LazyExoticComponent } from 'react';
import { Navigate, useLocation, type RouteObject } from 'react-router';
import { PageSkeleton } from '../../components/Page';

const pages = {
  home: lazy(() => import('./pages/SettingsHome')),
  general: lazy(() => import('./pages/GeneralPage')),
  store: lazy(() => import('./pages/StorePage')),
  products: lazy(() => import('./pages/ProductsSettingsPage')),
  receipt: lazy(() => import('./pages/ReceiptPage')),
  payments: lazy(() => import('./pages/PaymentsPage')),
  onlinePayments: lazy(() => import('./pages/OnlinePaymentsPage')),
  pricing: lazy(() => import('./pages/PricingPage')),
  sales: lazy(() => import('./pages/SalesPage')),
  shipping: lazy(() => import('./pages/ShippingPage')),
  exports: lazy(() => import('./pages/ExportsPage')),
  integrations: lazy(() => import('./pages/IntegrationsPage')),
  security: lazy(() => import('./pages/SecurityPage')),
  plan: lazy(() => import('./billing/PlanPage')),
  payInvoice: lazy(() => import('./billing/PayInvoicePage')),
  activity: lazy(() => import('./pages/ActivityPage')),
  privacy: lazy(() => import('./pages/PrivacyPage')),
  help: lazy(() => import('./pages/HelpPage')),
  notifications: lazy(() => import('./pages/NotificationsPage')),
};

function page(C: LazyExoticComponent<ComponentType>) {
  return (
    <Suspense fallback={<PageSkeleton />}>
      <C />
    </Suspense>
  );
}

/** Caminho antigo das opções de entrega: leva para Frete e entrega mantendo a âncora (#...) e a busca. */
function ToShipping() {
  const { search, hash } = useLocation();
  return <Navigate to={`/configuracoes/frete${search}${hash}`} replace />;
}

/** Rotas desta área (dentro do shell autenticado). */
export const routes: RouteObject[] = [
  { path: 'configuracoes', element: page(pages.home) },
  { path: 'configuracoes/geral', element: page(pages.general) },
  { path: 'configuracoes/loja', element: page(pages.store) },
  { path: 'configuracoes/produtos', element: page(pages.products) },
  { path: 'configuracoes/catalogo', element: <Navigate to="/catalogo" replace /> },
  { path: 'configuracoes/recibo', element: page(pages.receipt) },
  { path: 'configuracoes/pagamentos', element: page(pages.payments) },
  { path: 'configuracoes/pagamentos-online', element: page(pages.onlinePayments) },
  { path: 'configuracoes/precos', element: page(pages.pricing) },
  { path: 'configuracoes/vendas', element: page(pages.sales) },
  { path: 'configuracoes/frete', element: page(pages.shipping) },
  { path: 'configuracoes/entrega', element: <ToShipping /> },
  { path: 'configuracoes/exportar', element: page(pages.exports) },
  { path: 'configuracoes/integracoes', element: page(pages.integrations) },
  { path: 'configuracoes/seguranca', element: page(pages.security) },
  { path: 'configuracoes/plano', element: page(pages.plan) },
  { path: 'configuracoes/plano/pagar/:invoiceId', element: page(pages.payInvoice) },
  { path: 'configuracoes/atividades', element: page(pages.activity) },
  { path: 'configuracoes/privacidade', element: page(pages.privacy) },
  { path: 'configuracoes/*', element: <Navigate to="/configuracoes" replace /> },
  { path: 'ajuda', element: page(pages.help) },
  { path: 'notificacoes', element: page(pages.notifications) },
];

/** Rotas protegidas sem o shell (ex.: impressão). */
export const fullscreenRoutes: RouteObject[] = [];
